import React from "react";
import { formatDate, oddToString } from "../../data/utils";
import { getLabel } from "../../InitData";
import './OddsVariation.css'


function OddsVariation(props){

    const selection = props.selection;
	const aliasCode = selection.alias? (selection.alias + ' ') : '';
    let descSportTournament = null;
    if(props.selection.descSport != null && props.selection.descSport.length > 0){
    	descSportTournament = props.selection.descSport;
    }
    
    if(props.selection.descTournament != null && props.selection.descTournament.length > 0){
    	if(descSportTournament == null){
    		descSportTournament = "";
    	}
    	else{
    		descSportTournament = descSportTournament + " - ";
    	}
    	descSportTournament =  descSportTournament + props.selection.descTournament;
    }
    
    const homeTeam = selection.descEvent.split(" - ")[0];
    const awayTeam = selection.descEvent.split(" - ")[1];
    

    
  return <>

	  <div className={'scommessa'+ (selection.closed? " opacityEventClosed":"") } pal={selection.pal} avv={selection.avv}>
	  {
		  selection.closed &&(
				  <div className="eventClosed">{props.isMobile?getLabel('betslip.event.event_closed'):getLabel('carrello.event.event_closed')}</div>
		  )
	  }
	  
	  	<div className='scommessa__header'>
	        <div className='scommessa__header__left'>
		          <div className='scommessa__lega variationModal'>
		            <span className='scommessa__lega__alias '>{aliasCode}</span>
		            <span className='scommessa__lega__separatore'></span>
		            <span className='scommessa__lega__testo'>{descSportTournament}</span>
		            <span className='scommessa__lega__separatore'></span>
		            <span className=''>
		              {formatDate(selection.timestamp).formatted}
		            </span>
		            {selection.isLive && 
		            <div className="live-badge"></div>
		            }
		          </div>
		          <div className='scommessa__evento__containerSquadre variationModal'>
		            <span className='scommessa__evento__squadra'>
		            	{homeTeam}
		            </span>
		            <span className='scommessa__evento__separatore'>-</span>
		            <span className='scommessa__evento__squadra'>
		            	{awayTeam}
		            </span>
		          </div>
	        </div>
      </div>
      {
    	  !selection.closed && <>
    	  {
    		  selection.bets.map((bet, betIndex) => {
    			
    			  return <React.Fragment key={betIndex}>
    			  	  {
    			  		  (bet.updated || bet.closed) && 
		    			  <div className={'scommessa__body'} pal={selection.pal} avv={selection.avv} scom={bet.scomSogei} handicap={bet.handicap} draw={bet.draw}>
		    	        	<div className='scommessa__esito'>
			    	            <span className={'scommessa__esito__descrizione'  + (bet.closed? ' opacityEventClosed' : '')}>{bet.descBet}</span>
			    	            <span className={'scommessa__esito__esitoSelezionato' + (bet.closed? ' opacityEventClosed' : '')}>{bet.descDraw}</span>
			    	            <span className='scommessa__esito__spacer'></span>
			    	            {
			    	            	!bet.closed && bet.oldOdd &&
			    	            	<span className={'scommessa__esito__valoreQuota'}> {oddToString(bet.oldOdd)} <i className="fa fa-arrow-right" /> </span>
			    	            }
			    	            
			    	            <span className={'scommessa__esito__valoreQuota' + (bet.updated != null? (bet.updated === 'increased'? ' verde':' rosso') : '') + (bet.closed? ' playabilityClosed':'')}>
			    	            	{bet.closed? getLabel('general.giocabilita_chiusa') :oddToString(bet.odd)}
			    	          	{bet.updated &&(
			    	  					<span className={"arrow-" + (bet.updated === 'increased'? 'up':'down')}> </span>
			    	  			)}
			    	            </span>
			    	            {
			    	  				bet.updated &&(
			    	  						<span className={"variationDesc grassetto " + (bet.updated === 'increased'? ' verde':' rosso')}>{props.isMobile?getLabel('betslip.var_quota'):getLabel('carrello.var_quota.title')}</span>
			    	  				)
			    	            }
		    	            </div>
		    	          </div>
    			  	  }

    	         </React.Fragment>
    		  })
    	  }
    	  </>
      }

    </div>
  </>
}

export default OddsVariation;